import { ReactNode } from "react";
import { StyledLink } from "./styles";

type ActionItemLinkProps = {
	url: string;
	children: ReactNode;
};

export function ActionItemLink({ url, children }: ActionItemLinkProps) {
	return <StyledLink to={url}>{children}</StyledLink>;
}
